var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("ExcelConfig.Title"),
        visible: _vm.dialogVisible,
        width: "500px",
        "before-close": _vm.hide,
        "destroy-on-close": "",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "timeForm",
          attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("BusinessPurchaseComponentsCom.invoiceNo"),
                prop: "invoiceNumber",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                },
                model: {
                  value: _vm.form.invoiceNumber,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "invoiceNumber", $$v)
                  },
                  expression: "form.invoiceNumber",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("billingPage.OrderPostagetime"),
                prop: "invoiceDate",
              },
            },
            [
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  id: "getWeekDate1",
                  type: "week",
                  format: "yyyy-WW",
                  clearable: false,
                  placeholder: _vm.$t("billingPage.yearAndWeeks"),
                },
                on: { change: _vm.changeWeek1 },
                model: {
                  value: _vm.weekDataNow1,
                  callback: function ($$v) {
                    _vm.weekDataNow1 = $$v
                  },
                  expression: "weekDataNow1",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("InternalOrderList.company"),
                prop: "logisticsCompany",
              },
            },
            [
              _c("BjSelectLov", {
                attrs: { "option-list": _vm.companyList },
                model: {
                  value: _vm.form.logisticsCompany,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "logisticsCompany", $$v)
                  },
                  expression: "form.logisticsCompany",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("billingPage.ImportCSV"),
                prop: "fileList",
              },
            },
            [
              _c(
                "el-upload",
                {
                  attrs: {
                    accept: ".csv,.xls,.xlsx",
                    action: "",
                    limit: 1,
                    "auto-upload": false,
                    "on-remove": _vm.handleRemove,
                    "on-change": _vm.importFile,
                  },
                },
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("BusinessImportHistory.page.SelectFile"))
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("billingPage.OrderPostageImportPDF"),
                prop: "fileTest",
              },
            },
            [
              _c(
                "UploadFile",
                {
                  ref: "UploadFileRef",
                  staticClass: "avatar-uploader",
                  attrs: {
                    limit: 20,
                    "limit-size": 5 * 1024,
                    multiple: "",
                    "show-file-list": "",
                    accept: ".pdf",
                    "accept-list": [".pdf"],
                    "auto-upload": "",
                    "limit-hide": "",
                  },
                  on: { handleFileListChange: _vm.fileListChange },
                },
                [
                  _c(
                    "template",
                    { slot: "default" },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "mini", type: "primary" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessImportHistory.page.SelectFile")
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.hide } }, [
            _vm._v(_vm._s(_vm.$t("cancelText"))),
          ]),
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.confirmVisible, type: "primary" },
              on: { click: _vm.confirm },
            },
            [_vm._v(_vm._s(_vm.$t("ExcelConfig.Confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }